module.exports = __webpack_public_path__ + "static/media/About_hero.6f24e587.jpg";